<template>
  <div class="downloadbar" v-if="isShow">
    <img src="//i0.ulecdn.com/i/global/ule.png" />
    <p>
      邮政919，狂欢一整月
      <br />疯抢1亿购物津贴
    </p>
    <a href="javascript:void(0)" @click="download" class="btn-download" title="立即下载">立即下载</a>
    <i class="btn-closebar" @click="close">×</i>
  </div>
</template>  

<script>
import Vue from "vue";
import * as URL from "../../assets/js/url.js";
export default {
  data() {
    return {
      isShow: true,
      href:
        "//www." +
        URL.doMain +
        "/event/2018/0511/bargain/index.html?adid=dw_wap_mainkj"
    };
  },
  created() {},
  computed: {},
  methods: {
    close() {
      this.isShow = false;
    },
    download() {
      this.BASE.openApp();
    }
  }
};
</script>
<style lang="less" scoped>
.downloadbar {
  width: 100%;
  max-width: 640px;
  height: 60px;
  margin: 0 auto;
  padding: 10px 95px 10px 84px;
  box-sizing: border-box;
  position: relative;
  background-color: rgba(0, 0, 0, 0.7);
}
.downloadbar img {
  position: absolute;
  left: 37px;
  top: 10px;
  width: 40px;
}
.downloadbar p {
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: #fff;
  line-height: 20px;
}
.downloadbar .btn-download {
  position: absolute;
  right: 10px;
  top: 15px;
  display: block;
  width: 74px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  background-color: #f52626;
  color: #fff;
  font-size: 12px;
  text-align: center;
}
.downloadbar .btn-closebar {
  position: absolute;
  left: 7px;
  top: 20px;
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  font-style: normal;
  background-color: #262626;
  color: #fff;
  font-size: 16px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/downloadHead.vue